import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost/PSH2OCorpApi/',
   baseURL: 'https://app.poolsharkh2o.com/PSH2OCorpApi/',
});

export default instance;